import { authContext } from "@/auth";
import { computed } from '@vue/composition-api';

export function useCurrentUser() {
    const user = computed(() => {
        return authContext.authenticated() ? authContext.user : null;
    })

    const roles = computed(() => ((user.value?.profile.resource_access as ResourceAccess).salesman?.roles) ?? [] )

    const subsidiary = computed(() => user.value?.profile.subsidiary_code ?? null);

    return {
        user,
        roles,
        subsidiary
    }
}

interface ResourceAccess {
    [key: string]: {
        roles: string[];
    };
}